// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App'
import router from './router'
import store from './store'
import { firestorePlugin } from 'vuefire'
import { rtdbPlugin } from 'vuefire'
import FirebaseAuthPlugin from './FirebaseAuthPlugin'
import VuePageTransition from 'vue-page-transition'

Vue.use(firestorePlugin)
Vue.use(rtdbPlugin)
Vue.use(FirebaseAuthPlugin)
sync(store, router)
Vue.use(VuePageTransition)

import firebase from 'firebase/app'
import 'firebase/firestore'
const firestore = firebase.firestore()
const settings = {
  timestampsInSnapshots: true
}
firestore.settings(settings)
export const db = firestore

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    titleCase(str) {
      // console.log(str)
      return str.toLowerCase().split(' ').map(function (word) {
        if(!word[0]) return
        return word.replace(word[0], word[0].toUpperCase());
      }).join(' ');
    },
    slugify: (string) => {
      const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
      const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
      const p = new RegExp(a.split('').join('|'), 'g')
      return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
    },
    rollDice(min, max) {
      return min + Math.floor(Math.random() * (max - min + 1))
    },
    randomIndex(max) {
      return Math.floor(Math.random() * max)
    },
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js